import Nav from "../components/Nav";
import HostBio from "../components/about/HostBio";
import Footer from "../components/Footer";
import edenHeadshot from "../assets/eden_headshot.jpeg";
import ellenHeadshot from "../assets/ellen_headshot.png";

export function About() {
  return (
    <div className="min-h-screen bg-cream">
      <Nav />

      {/* Hero */}
      <section className="relative bg-burgundy overflow-hidden">
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage:
              "radial-gradient(circle at 30% 40%, #a72913 0%, transparent 50%), radial-gradient(circle at 70% 60%, #c2858c 0%, transparent 50%)",
          }}
        />
        <div className="relative max-w-4xl mx-auto px-6 py-20 text-center">
          <p
            className="font-montserrat text-cream uppercase mb-3 animate-fade-up"
            style={{ fontSize: "16px", letterSpacing: "0.2em", opacity: 0.85 }}
          >
            Readme.md
          </p>
          <h1
            className="font-playfair text-cream text-[62px] md:text-[78px] leading-[1.05] mb-2 animate-fade-up"
            style={{ animationDelay: "100ms" }}
          >
            ABOUT{" "}
            <span
              className="font-script italic text-tgc-pink-soft"
              style={{ fontSize: "2.15em" }}
            >
              us
            </span>
          </h1>
          <p
            className="font-montserrat text-cream/90 max-w-xl mx-auto mt-6 animate-fade-up"
            style={{
              fontSize: "20px",
              lineHeight: 1.65,
              animationDelay: "200ms",
            }}
          >
            By the girlies, for the girlies. That's Girl Code is a tech brand
            for the girl in STEM who's been waiting for one. Catch us on the
            podcast: a weekly standup where we talk all things tech that didn't
            quite make it into the group chat.
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="max-w-5xl mx-auto px-6 py-20 animate-fade-up">
        <h2
          className="font-montserrat text-stone-800 uppercase text-center mb-4"
          style={{ fontSize: "16px", letterSpacing: "0.18em", fontWeight: 600 }}
        >
          Our Story
        </h2>
        <p className="font-montserrat text-stone-600 text-[18px] leading-relaxed max-w-2xl mx-auto text-center mb-6">
          We met at our first job post grad and bonded over our shared
          experience of being one of only a few women in the room. The more we
          talked, the more obvious it became that this couldn’t be unique to
          just us. There were too many other smart, ambitious girls who needed
          the kind of friendship every girl in tech secretly hopes for: someone
          who gets the code, the career stress, the office politics.
        </p>
        <p className="font-montserrat text-stone-600 text-[18px] leading-relaxed max-w-2xl mx-auto text-center">
          So we built the community we wished we'd had. That's Girl Code
          launched in July 2025. Our v1.0, merge to main, first real commit to
          all women in STEM who deserve a space that actually feels like theirs.
          That’s Girl Code is where we talk software, AI, the realities of the
          industry and everything in between. We’re so happy to have you here.
        </p>
      </section>

      {/* Meet the Hosts */}
      <section className="bg-dustyrose/20 py-20">
        <div className="max-w-5xl mx-auto px-6">
          <h2
            className="font-montserrat text-stone-800 uppercase text-center mb-14"
            style={{
              fontSize: "16px",
              letterSpacing: "0.18em",
              fontWeight: 600,
            }}
          >
            Meet the Contributors
          </h2>

          <div className="flex flex-col md:flex-row gap-12 md:gap-16">
            <HostBio
              image={edenHeadshot}
              name="Eden"
              title="Mobile Engineer"
              description="Eden is a software engineer and tech enthusiast with five years of experience building everything from back-end services to sleek front-end moments. But her true love? Mobile development, specifically iOS. As a co-host of That's Girl Code, Eden is here to spill the tech tea and prove that software engineering can (and should) be for the girlies.
When she's not shipping code or recording episodes, you can find her experimenting with new frameworks, mentoring early-career engineers, or binge watching Bravo reality shows."
            />
            <HostBio
              image={ellenHeadshot}
              name="Ellen"
              title="Co-Host"
              description="Ellen is a data strategist and tech enthusiast who lives at the intersection of data engineering and software development. She loves all things tech: the platforms, the pipelines, the possibilities, and yes, the drama. As a co-host of That's Girl Code, Ellen is here to prove that data engineering is just as glamorous as it sounds.
When she's not driving platform adoption or geeking out over the latest AI developments and agentic systems, you can find her deep diving into research rabbit holes and staying on top of all the relevant tech news.
"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
